import {
  ArrowOverlay,
  InputWithLabel,
  TextareaWithLabel,
  TooltipForChild,
  uiStyles,
  useNextDropDown,
  XPlainButton,
  XText,
  XTextButton,
} from "@cdx/common";
import copy from "copy-to-clipboard";
import {Col, DSIconButton, DSIconMail, DSIconShare, DSIconTwitter, Row} from "@cdx/ds";
import QueryString from "qs";
import cdxEnv from "../../env";
import useBling from "../../lib/hooks/useBling";
import {IconWhatsapp} from "../public-project-portal/components/Icon";

const getEmbedCode = (url) =>
  `<iframe src="${url}" style="width:100%;height:800px" frameborder="0"></iframe>`;

const ShareButton = (props) => <XTextButton color="white" size="xl" square {...props} />;

const CopyButton = ({value}) => {
  const [blingRef, setMessage] = useBling();
  const handleClick = () => {
    copy(value);
    setMessage("Copied");
  };
  return (
    <XPlainButton color="purple" size="sm" ref={blingRef} onClick={handleClick}>
      Copy
    </XPlainButton>
  );
};

const Overlay = ({overlayProps, project}) => {
  const rawUrl = `${cdxEnv.OPEN_APP_HOST}/${project.publicPath}`;
  const url = `${rawUrl}?utm_medium=share`;
  const title = project.publicHeading || project.name;
  return (
    <ArrowOverlay bg="purple600" arrowSize="xs" {...overlayProps}>
      <Col>
        <Col px={3} py={4} sp={3}>
          <XText preset="label" size={1} color="purple100">
            Share
          </XText>
          <Row sp={4} align="center">
            <ShareButton
              tooltip="Share via Mail"
              href={`mailto:someone@example.com?${QueryString.stringify({
                subject: title,
                body: url,
              })}`}
            >
              <DSIconMail size={20} />
            </ShareButton>
            <ShareButton
              tooltip="Share via Twitter"
              href={`https://twitter.com/intent/tweet?${QueryString.stringify({
                text: `${title} on ${url}`,
              })}`}
            >
              <DSIconTwitter size={20} />
            </ShareButton>
            <ShareButton
              tooltip="Share via WhatsApp"
              href={`whatsapp://send?${QueryString.stringify({
                text: `${title} on ${url}`,
              })}`}
            >
              <IconWhatsapp />
            </ShareButton>
          </Row>
        </Col>
        <Col className={uiStyles.backgroundColor.white} px={3} py={4} sp={3}>
          <InputWithLabel
            value={url}
            onClick={(e) => e.target.select()}
            readOnly
            label="url"
            postfix={<CopyButton value={url} />}
          />
          <TextareaWithLabel
            value={getEmbedCode(rawUrl)}
            onClick={(e) => e.target.select()}
            readOnly
            label="iframe Embed Code"
            minRows={1}
            maxRows={1}
            postfix={<CopyButton value={getEmbedCode(rawUrl)} />}
            fieldStyle={{resize: "none"}}
          />
        </Col>
      </Col>
    </ArrowOverlay>
  );
};

const PublicProjectShareButton = ({project}) => {
  const {ref, toggle, overlayElement, isOpen} = useNextDropDown({
    overlayProps: {
      placement: "right",
      distanceFromAnchor: 10,
      renderOverlay: ({close, ...props}) => (
        <Overlay overlayProps={props} project={project} close={close} />
      ),
    },
  });
  return (
    <>
      {overlayElement}
      <TooltipForChild tooltip={isOpen ? null : "Show sharing options"} ref={ref}>
        <DSIconButton
          onClick={toggle}
          icon={<DSIconShare />}
          size="sm"
          variant="tertiary"
          negatePadding
          active={isOpen}
        />
      </TooltipForChild>
    </>
  );
};

export default PublicProjectShareButton;
